/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';

const style: ouiStyle.InStyleWithMediaQueries = {
  position: 'relative',
};

export const SectionWrapper = (props: React.PropsWithChildren<{
  index: number,
  totalLength: number,
}>) => {
  const {
    children,
    index,
    totalLength,
  } = props;
  const css = React.useMemo(() => ouiStyle.mediaQuery(ouiStyle.makeCss({
    ...style,
    zIndex: totalLength - index,
  })), [index, totalLength]);
  return (
    <div
      css={css}
    >
      {children}
    </div>
  );
};
